import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { createApiClient } from '../../apiClient';

/**
 * Registers a new TOTP (Time-based One-Time Password) MFA device.
 *
 * This function initiates the registration of a TOTP authenticator app
 * (like Google Authenticator or Authy) for multi-factor authentication.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to the TOTP registration response containing setup information,
 * like the secret key and the OTP Auth URI.
 */
export const registerTotpMfaDevice = async (client = getDefaultClient()) => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  return apiClient.registerTotpMfaDevice({
    environmentId: core.environmentId,
  });
};
